(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/prescript.js');
"use strict";


svs = svs || {};
svs.widgetsCampaign = svs.widgetsCampaign || {};
svs.widgetsCampaign.components = svs.widgetsCampaign.components || {};

 })(window);